import { render, staticRenderFns } from "./student-card-4.vue?vue&type=template&id=7df4d09b&scoped=true"
import script from "./student-card-4.vue?vue&type=script&lang=js"
export * from "./student-card-4.vue?vue&type=script&lang=js"
import style0 from "./student-card-4.vue?vue&type=style&index=0&id=7df4d09b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4d09b",
  null
  
)

export default component.exports